module.exports = __webpack_public_path__ + "static/media/upload_share.e7bf1e8e.svg";